import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageLoader } from '@/components/common/PageLoader';

function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

// DEC-025 Move 1 W5 (2026-06-21): the qfinpricer market-data workbench ported into the qiyas portal.
// Reads the canonical market-data store (md_* schemas) via /api/v1/curve-definitions etc. The Build /
// Price tabs that call the QuantLib build endpoints become fully live with the fleet cutover (Move 2/3).
const CurvesWorkbenchPage = lazy(() => import('@/modules/market-data/workbench/CurvesWorkbenchPage'));
const CurveBuilderPage = lazy(() => import('@/modules/market-data/pages/CurveBuilderPage'));
const CreditCurveBuilderPage = lazy(() => import('@/modules/market-data/pages/CreditCurveBuilderPage'));
const VolSurfaceViewerPage = lazy(() => import('@/modules/market-data/pages/VolSurfaceViewerPage'));

export default function MarketDataRoutes() {
  return (
    <>
      {/* Market Data — Curves Workbench (canonical store) */}
      <Route path="/data/market/curves-workbench" element={<ProtectedRoute><MainLayout><LazyPage><CurvesWorkbenchPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/data/market/curve-builder" element={<ProtectedRoute><MainLayout><LazyPage><CurveBuilderPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/data/market/credit-curve-builder" element={<ProtectedRoute><MainLayout><LazyPage><CreditCurveBuilderPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/data/market/vol-surface-viewer" element={<ProtectedRoute><MainLayout><LazyPage><VolSurfaceViewerPage /></LazyPage></MainLayout></ProtectedRoute>} />
    </>
  );
}
